/**
 * TribeX product fit quiz — storefront behavior.
 * Reads JSON from #tq-quiz-settings and optional HTML from <template> ids.
 */
(function () {
  'use strict';

  function readSettings() {
    var el = document.getElementById('tq-quiz-settings');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return {};
    }
  }

  var settings = readSettings();
  var A = {
    q1: '',
    q2: '',
    q3: '',
    q4: '',
    q5: '',
    q6: '',
    q7: '',
    q8: '',
    q9: '',
    q10: '',
    q11: '',
  };
  var totalQ = 11;
  var curScreen = 'intro';
  var isBeautyPath = false;

  var ARROW_RIGHT =
    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';

  function showScreen(id) {
    document.querySelectorAll('.tq-screen').forEach(function (s) {
      s.classList.remove('tq-screen--active');
      s.style.display = 'none';
    });
    var el = document.getElementById('tq-s-' + id);
    if (!el) return;
    el.style.display = 'block';
    el.style.animation = 'none';
    void el.offsetHeight;
    el.style.animation = '';
    el.classList.add('tq-screen--active');
    curScreen = id;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function updateProg(step) {
    var fill = document.getElementById('tq-prog-fill');
    var label = document.getElementById('tq-prog-label');
    var pctEl = document.getElementById('tq-prog-pct');
    if (!fill || !label || !pctEl) return;
    var pct = Math.round((step / totalQ) * 100);
    fill.style.width = pct + '%';
    var tmpl = settings.progress_label || 'Question {current} of {total}';
    label.textContent = tmpl.replace('{current}', String(step)).replace('{total}', String(totalQ));
    pctEl.textContent = pct + '%';
  }

  function startQuiz() {
    var wrap = document.getElementById('tq-prog-wrap');
    if (wrap) wrap.classList.add('tq-prog-wrap--visible');
    updateProg(1);
    showScreen('q1');
  }

  function goBack(target) {
    var stepMap = {
      intro: 0,
      q1: 1,
      i1: 1,
      q2: 2,
      q3: 3,
      i2: 3,
      q4: 4,
      q5: 5,
      i3: 5,
      q6: 6,
      q7: 7,
      i4: 7,
      q8: 8,
      q9: 9,
      i5: 9,
      q10: 10,
      q11: 11,
    };
    var s = stepMap[target] || 1;
    var wrap = document.getElementById('tq-prog-wrap');
    if (s > 0) {
      if (wrap) {
        wrap.style.display = '';
        wrap.classList.add('tq-prog-wrap--visible');
      }
      updateProg(s);
    } else if (wrap) {
      wrap.classList.remove('tq-prog-wrap--visible');
    }
    showScreen(target);
  }

  function optsParent(qId) {
    return document.getElementById('tq-' + qId + '-opts');
  }

  function selectQ(card, qId) {
    var parent = optsParent(qId);
    if (!parent) return;
    parent.querySelectorAll('.tq-opt').forEach(function (c) {
      c.classList.remove('tq-opt--selected');
    });
    card.classList.add('tq-opt--selected');
    A[qId] = card.getAttribute('data-value') || '';

    if (qId === 'q1') {
      isBeautyPath = A.q1 === 'beauty' || A.q1 === 'wellness';
      setTimeout(function () {
        showScreen('i1');
      }, 350);
    } else if (qId === 'q3') {
      setTimeout(function () {
        showScreen('i2');
      }, 350);
    } else if (qId === 'q4') {
      updateProg(5);
      setTimeout(function () {
        showScreen('q5');
      }, 350);
    } else if (qId === 'q5') {
      setTimeout(function () {
        showScreen('i3');
      }, 350);
    } else if (qId === 'q6') {
      updateProg(7);
      setTimeout(function () {
        showScreen('q7');
      }, 350);
    } else if (qId === 'q7') {
      buildI4();
      setTimeout(function () {
        showScreen('i4');
      }, 350);
    } else if (qId === 'q8') {
      updateProg(9);
      setTimeout(function () {
        showScreen('q9');
      }, 350);
    } else if (qId === 'q9') {
      setTimeout(function () {
        showScreen('i5');
      }, 350);
    } else if (qId === 'q10') {
      updateProg(11);
      setTimeout(function () {
        showScreen('q11');
      }, 350);
    } else if (qId === 'q11') {
      var progWrap = document.getElementById('tq-prog-wrap');
      if (progWrap) progWrap.style.display = 'none';
      setTimeout(function () {
        showScreen('email');
      }, 350);
    }
  }

  function selectGender(card) {
    document.querySelectorAll('.tq-gender-card').forEach(function (c) {
      c.classList.remove('tq-gender-card--selected');
    });
    card.classList.add('tq-gender-card--selected');
    A.q2 = card.getAttribute('data-value') || '';
    updateProg(3);
    setTimeout(function () {
      showScreen('q3');
    }, 350);
  }

  function buildI4() {
    var el = document.getElementById('tq-i4-content');
    var tid = isBeautyPath ? 'tq-tpl-i4-beauty' : 'tq-tpl-i4-athletic';
    var tpl = document.getElementById(tid);
    if (!el || !tpl) return;
    var continueLabel = settings.continue_label || 'Continue';
    el.innerHTML = tpl.innerHTML + '<div class="tq-next-wrap"><button type="button" class="tq-btn-primary" id="tq-i4-continue">' + continueLabel + ' ' + ARROW_RIGHT + '</button></div>';
    var btn = document.getElementById('tq-i4-continue');
    if (btn) {
      btn.addEventListener('click', function () {
        buildQ8();
        showScreen('q8');
        updateProg(8);
      });
    }
  }

  function buildQ8() {
    var el = document.getElementById('tq-q8-content');
    var tid = isBeautyPath ? 'tq-tpl-q8-beauty' : 'tq-tpl-q8-athletic';
    var tpl = document.getElementById(tid);
    if (!el || !tpl) return;
    el.innerHTML = tpl.innerHTML;
    el.querySelectorAll('.tq-opt[data-value]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        selectQ(opt, 'q8');
      });
    });
  }

  function submitEmail() {
    var input = document.getElementById('tq-email-input');
    var err = document.getElementById('tq-email-error');
    var btn = document.getElementById('tq-email-submit');
    if (!input || !btn) return;
    var email = input.value.trim();
    var valid = email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!valid) {
      if (err) err.style.display = 'block';
      return;
    }
    if (err) err.style.display = 'none';
    btn.disabled = true;
    btn.textContent = settings.email_submit_loading || 'Analyzing...';

    var companyId = settings.klaviyo_company_id || '';
    var listId = settings.klaviyo_list_id || '';
    if (companyId && listId) {
      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: settings.klaviyo_custom_source || 'Tribex Quiz V2',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: {
                    quiz_v2_goal: A.q1,
                    quiz_v2_gender: A.q2,
                    quiz_v2_morning: A.q3,
                    quiz_v2_confusion: A.q4,
                    quiz_v2_supplements: A.q5,
                    quiz_v2_exercise: A.q6,
                    quiz_v2_seriousness: A.q7,
                    quiz_v2_branch: A.q8,
                    quiz_v2_gut: A.q9,
                    quiz_v2_natural: A.q10,
                    quiz_v2_budget: A.q11,
                    quiz_v2_path: isBeautyPath ? 'beauty' : 'athletic',
                    quiz_v2_completed: 'true',
                    quiz_v2_date: new Date().toISOString().split('T')[0],
                  },
                },
              },
            },
          },
          relationships: {
            list: { data: { type: 'list', id: listId } },
          },
        },
      };
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2025-01-15' },
        body: JSON.stringify(payload),
      }).catch(function () {});
    }

    showScreen('loading');
    setTimeout(function () {
      showScreen('confirmation');
    }, 2200);
  }

  function onKeyDown(e) {
    if (e.key === 'Enter' && curScreen === 'email') {
      submitEmail();
    }
  }

  window.TribexQuiz = {
    startQuiz: startQuiz,
    goBack: goBack,
    selectQ: selectQ,
    selectGender: selectGender,
    submitEmail: submitEmail,
  };

  function init() {
    var i1c = document.getElementById('tq-i1-continue');
    if (i1c) {
      i1c.addEventListener('click', function () {
        showScreen('q2');
      });
    }
    var i2c = document.getElementById('tq-i2-continue');
    if (i2c) {
      i2c.addEventListener('click', function () {
        updateProg(4);
        showScreen('q4');
      });
    }
    var i3c = document.getElementById('tq-i3-continue');
    if (i3c) {
      i3c.addEventListener('click', function () {
        updateProg(6);
        showScreen('q6');
      });
    }
    var i5c = document.getElementById('tq-i5-continue');
    if (i5c) {
      i5c.addEventListener('click', function () {
        updateProg(10);
        showScreen('q10');
      });
    }

    document.addEventListener('keydown', onKeyDown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
